/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'LOAD_FAQS',
  'LOAD_FAQ_SECTIONS',
]);



// WEBPACK FOOTER //
// ./src/constants/FaqConstants.js